export default object => {
    if (!object) {
        return null;
    }
    return JSON.parse(JSON.stringify(object));
};
